import { unsafeCSS, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { appendStylesheet } from "../../utilities/light-dom-styles.js";
import { LeafElement } from "../leaf-element.js";
const styles = ".leaf-c-inputgroup {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}";
const inputgroupSlotStyles = "leaf-inputgroup leaf-input {\n  flex: 1 1 auto;\n  margin-top: 0 !important;\n  width: 1%;\n}\nleaf-inputgroup leaf-input input {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  margin-top: 0;\n  margin-left: auto;\n  width: calc(100% - var(--leaf-spacing-4));\n}\nleaf-inputgroup leaf-input::part(body) {\n  width: 100%;\n}\nleaf-inputgroup leaf-button {\n  margin-top: 0 !important;\n}\nleaf-inputgroup leaf-button::part(base) {\n  margin-left: calc(var(--bs-border-width) * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: calc(var(--leaf-spacing-16) * 3.5);\n}\nleaf-inputgroup leaf-label {\n  margin-bottom: var(--leaf-spacing-4);\n  width: 100%;\n}\nleaf-inputgroup leaf-validation-message,\nleaf-inputgroup span {\n  margin-left: var(--leaf-spacing-4);\n  margin-top: var(--leaf-spacing-4);\n  width: 100%;\n}";
const _LeafInputgroup = class _LeafInputgroup extends LeafElement {
  constructor() {
    super();
    appendStylesheet("leaf-inputgroup-styles", inputgroupSlotStyles, this);
  }
  render() {
    const componentClassName = {
      "leaf-c-inputgroup": true
    };
    return html` <div class=${classMap(componentClassName)}>
      <slot></slot>
    </div>`;
  }
};
_LeafInputgroup.styles = unsafeCSS(styles);
let LeafInputgroup = _LeafInputgroup;
export {
  LeafInputgroup
};
//# sourceMappingURL=inputgroup.component.js.map
